export const name = "LTRIM";
export const summary = `Identical to the \`TRIM\` function, but only removes leading characters.`;
export const reference = `
## LTRIM

Identical to the \`TRIM\` function, but only removes leading characters.

\`\`\`
LTRIM(value1[, value2])
\`\`\`

### Description

Identical to TRIM, but only removes leading characters.


### Return type

\`STRING\` or \`BYTES\`


### Examples



\`\`\`
SELECT CONCAT('#', LTRIM(' apple '), '#') AS example

/*-------------*
 | example |
 +-------------+
 | #apple # |
 *-------------*/
\`\`\`



\`\`\`
SELECT LTRIM(' ***apple***', '*') AS example

/*-----------*
 | example |
 +-----------+
 | apple*** |
 *-----------*/
\`\`\`



\`\`\`
SELECT LTRIM('xxxapplexxx', 'xyz') AS example

/*-----------*
 | example |
 +-----------+
 | applexxx |
 *-----------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
